import React from 'react';

import PropTypes from 'prop-types';
import { faSpinnerThird } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { formatDate } from '../utils';

const ResumeButton = ({ children, isLoading, onClick }) => {
  if (isLoading) {
    return (
      <Button disabled>
        <FontAwesomeIcon className="animate-spin" icon={faSpinnerThird} />
        Please wait
      </Button>
    );
  }

  return <Button onClick={onClick}>{children}</Button>;
};

ResumeButton.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const ResumeSubscriptionMenu = ({ cancelAt, canManage, isSubmitting, onResume }) => (
  <>
    <p className="text-sm">Your subscription ends on {formatDate(cancelAt)}.</p>

    {canManage && (
      <ResumeButton isLoading={isSubmitting} onClick={onResume}>
        Resume subscription
      </ResumeButton>
    )}
  </>
);

ResumeSubscriptionMenu.propTypes = {
  cancelAt: PropTypes.string.isRequired,
  canManage: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onResume: PropTypes.func.isRequired,
};

export default ResumeSubscriptionMenu;
